import { render } from "./CompanyAboutUs.vue?vue&type=template&id=62eb88ce&scoped=true&ts=true"
import script from "./CompanyAboutUs.vue?vue&type=script&lang=ts"
export * from "./CompanyAboutUs.vue?vue&type=script&lang=ts"

import "./CompanyAboutUs.vue?vue&type=style&index=0&id=62eb88ce&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62eb88ce"]])

export default __exports__